<template>
    <div>
        <h1 class="mb-1">Webseitengeschwindigkeit 2
            <v-tooltip right>
                <template v-slot:activator="{ on }">
                    <v-icon @click.stop="dialog3 = true" color="primary" class="ml-2" dark v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>Beschreibung</span>
            </v-tooltip>
        </h1>
        <div class="mb-5 grey--text text--darken-1 font-regular">Wie schnell wird Ihre Website geladen und Ihren Webseitenbesuchern angezeigt?</div>
        <v-dialog v-model="dialog3" max-width="500">
            <v-card>
                <v-card-title class="headline">Webseitengeschwindigkeit</v-card-title>
                <v-card-text>
                    <p>Die Tests werden von einem Server in Zürich aus durchgeführt und entsprechen bei Mobile der Ladegeschwindigkeit mit 3G Netzwerk-Empfang als Voraussetzung. Die Tests und der Score entsprechen den Daten aus dem <a target="_blank" href="https://developers.google.com/web/tools/lighthouse/v3/scoring">Lighthouse Performance</a> Score.</p>
                    <div><v-img alt="Google Lighthouse Score" class="shrink" contain src="@/assets/google-lighthouse.png" transition="scale-transition" width="800" /></div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog3 = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="product-full mb-10" v-if="!preview">
            <v-card>
                <v-card-text>
                    <p class="subtitle-1 font-weight-regular">Die Webseitengeschwindigkeit ist einer der Schlüssel für Umsätze und somit für Wachstum. Umso langsamer die einzelnen Seiten geladen werden, desto mehr Kunden brechen den Kaufprozess frühzeitig ab.</p>
                    <p class="subtitle-1 font-weight-regular"><strong>Amazon rechnete einst aus, dass sich pro 0.1 Sekunden Verbesserung der Ladezeit der Webseite der Umsatz um 1% erhöht.</strong></p>
                </v-card-text>
            </v-card>
        </div>

        <div class="product-small" v-if="preview">
            <v-progress-linear :indeterminate="true" v-if="loading" />
            <apex-line-chart v-if="!loading" :x="desktop.score.x" :y="desktop.score.y" />
        </div>
        <div class="product-full" v-if="!preview">
            <v-progress-linear :indeterminate="true" v-if="loading" />
            
            <v-card v-if="!loading">
                <v-card-text>
                    <v-tabs color="primary" class="pl-3 pr-3">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab href="#desktop">Desktop</v-tab>
                        <v-tab href="#mobile">Mobile</v-tab>

                        <v-tab-item value="desktop">
                            <v-data-table :hide-default-footer="true" :headers="table.header" :items="table.body" class="elevation-1 non-branded-table mt-5" mobile-breakpoint="0">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td v-for="(c, i) in table.header" :key="i" :align="c.align" style="padding:8px">
                                            <div v-if="c.value == 'domain'" class="d-flex flex-column">
                                                <div class="non-branded-table-title">{{ item[c.value] }}</div>
                                                <div class="non-branded-table-subtitle">Median</div>
                                                <div class="non-branded-table-subtitle">Downtime (Minuten)</div>
                                            </div>
                                            <div v-if="c.month" class="d-flex flex-column" :align="c.align">
                                                <div class="d-flex justify-start">
                                                    <v-tooltip right>
                                                        <template v-slot:activator="{ on }">
                                                            <div @click.stop="dialog3 = true" v-on="on" style="cursor: pointer; padding-right:10px">
                                                                <div class="non-branded-table-title"></div>
                                                                <div class="score">
                                                                    <span>{{ item[c.value].desktop.score }}</span>
                                                                    <v-progress-circular :value="item[c.value].desktop.score" :color="color(item[c.value].desktop.score)" size="38" :rotate="-90" />
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <span>Was ist das?</span>
                                                    </v-tooltip>
                                                    <div>
                                                        <div class="non-branded-table-title"></div>
                                                        <div class="d-flex">
                                                            {{ seconds(item[c.value].desktop.speedMedian) }}
                                                        </div>
                                                        <div class="d-flex">
                                                            {{ item[c.value].downtime + " m" }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                        <v-tab-item value="mobile">
                            <v-data-table :hide-default-footer="true" :headers="table.header" :items="table.body" class="elevation-1 non-branded-table mt-5" mobile-breakpoint="0">
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td v-for="(c, i) in table.header" :key="i" :align="c.align" style="padding:8px">
                                            <div v-if="c.value == 'domain'" class="d-flex flex-column">
                                                <div class="non-branded-table-title">{{ item[c.value] }}</div>
                                                <div class="non-branded-table-subtitle">Median</div>
                                                <div class="non-branded-table-subtitle">Downtime (Minuten)</div>
                                            </div>
                                            <div v-if="c.month" class="d-flex flex-column" :align="c.align">
                                                <div class="d-flex justify-start">
                                                    <v-tooltip right>
                                                        <template v-slot:activator="{ on }">
                                                            <div @click.stop="dialog3 = true" v-on="on" style="cursor: pointer; padding-right:10px">
                                                                <div class="non-branded-table-title"></div>
                                                                <div class="score">
                                                                    <span>{{ item[c.value].mobile.score }}</span>
                                                                    <v-progress-circular :value="item[c.value].mobile.score" :color="color(item[c.value].mobile.score)" size="38" :rotate="-90" />
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <span>Was ist das?</span>
                                                    </v-tooltip>
                                                    <div>
                                                        <div class="non-branded-table-title"></div>
                                                        <div class="d-flex">
                                                            {{ seconds(item[c.value].mobile.speedMedian) }}
                                                        </div>
                                                        <div class="d-flex">
                                                            {{ item[c.value].downtime + " m" }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
                <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            </v-card>

            <v-card class="mt-10" v-if="!loading">
                <v-card-text>
                    <v-tabs color="primary" class="pl-3">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab href="#desktop">Desktop</v-tab>
                        <v-tab href="#mobile">Mobile</v-tab>

                        <v-tab-item value="desktop">
                            <apex-line-chart v-show="chartType == 'score'" :x="desktop.score.x" :y="desktop.score.y" />
                            <apex-line-chart v-show="chartType == 'speed'" :x="desktop.speed.x" :y="desktop.speed.y" :format="seconds" :tooltip="seconds" />
                        </v-tab-item>
                        <v-tab-item value="mobile">
                            <apex-line-chart v-show="chartType == 'score'" :x="mobile.score.x" :y="mobile.score.y" />
                            <apex-line-chart v-show="chartType == 'speed'" :x="mobile.speed.x" :y="mobile.speed.y" :format="seconds" :tooltip="seconds" />
                        </v-tab-item>
                    </v-tabs>

                    <v-radio-group class="ml-5" v-model="chartType" row>
                        <v-radio label="Bewertung" value="score"></v-radio>
                        <v-radio label="Webseitengeschwingkeit" value="speed"></v-radio>
                    </v-radio-group>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .non-branded-table-title {
        font-weight: bold;
        height: 1.5em;
        font-size: 1.2em;
    }
    .non-branded-table-subtitle {
        opacity: .5;
        font-size: .9em;
    }
    .score {
        position: relative;

        > span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            font-size: 14px;
            line-height: 1em;
            margin-top: 2px;
            font-weight: 600;
        }
    }
</style>

<script>
import ApexLineChart from "@/components/charts/ApexLineChart";
import ProductMixin from "@/mixins/Product";
import moment from "moment";
import { seconds } from "@/helpers/format";
import { headers } from "@/helpers/table";

export default {
    data: () => ({
        dialog3: false,
        dialog4: false,
        chartType: "score",
        table: {
            header: [],
            body: []
        },
        desktop: {
            score: { x: [], y: [] },
            speed: { x: [], y: [] },
        },
        mobile: {
            score: { x: [], y: [] },
            speed: { x: [], y: [] },
        }
    }),
    mixins: [ProductMixin],
    methods: {
        seconds,
        color(value) {
            if (value <= 49)
                return "red";
            else if (value <= 89)
                return "orange";
            else
                return "green";
        },
        async loaded(data) {
            this.table.header = headers([
                { text: 'Domain', value: 'domain' },
                ...data.months.map(m => ({
                    text: moment(m).format("MMM YY"),
                    value: m,
                    align: 'left',
                    month: true
                }))
            ]);
            this.table.body = data.domains.map(d => Object.assign({
                    domain: d.domain
                },
                ...d.months.map(m => ({
                    [m.date]: m
                }))
            ));

            this.mobile.score.x = data.months.map(d => moment(d).format("MMM YY"));
            this.mobile.score.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.mobile.score)
            }));

            this.mobile.speed.x = data.months.map(d => moment(d).format("MMM YY"));
            this.mobile.speed.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.mobile.speedMedian)
            }));

            this.desktop.score.x = data.months.map(d => moment(d).format("MMM YY"));
            this.desktop.score.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.desktop.score)
            }));

            this.desktop.speed.x = data.months.map(d => moment(d).format("MMM YY"));
            this.desktop.speed.y = data.domains.map(d => ({
                name: d.domain,
                data: d.months.map(m => m.desktop.speedMedian)
            }));
        }
    },
    components: { ApexLineChart }
}
</script>